import React, { useEffect, useState } from 'react'
import styles from '../ModulosPagoSpei/pagoSpei.module.sass'

import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import { MenuCredito } from 'components/menuCredito'
import { ThanskPageSpei } from '../ModulosPagoSpei'


export default function PagoSpeiDesktop(props) {

    const {
        clabe,
        payCode,
        payCard,
        isMobile
    } = props

    return (
        <>
            <Header type="complete" />
            <div className={`container no-printme ${styles?.no_printme}`}>
                <div className={styles?.contCards}>

                    <MenuCredito />
                    <ThanskPageSpei
                        clabe={clabe}
                        payCode={payCode}
                        payCard={payCard}
                        isMobile={isMobile}
                    />
                </div>

            </div>
            <Footer type="complete" />
        </>
    )
}